import { ErrorInfo, Realtime, type RealtimeChannel } from "ably";

export const ablyClient = new Realtime({
  autoConnect: false,
  authCallback: async (_tokenParams, callback) => {
    try {
      const res = await fetch(`${import.meta.env.VITE_DOMAIN_API}/api/pubsub`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
      if (!res.ok) {
        throw new Error(`Ably auth failed: ${res.status}`);
      }
      const tokenRequest = await res.json();
      callback(null, tokenRequest);
    } catch (err) {
      const message = err instanceof Error ? err.message : "Ably auth failed";
      callback(new ErrorInfo(message, 40100, 401), null);
    }
  },
});

ablyClient.connection.on("disconnected", () => {
  console.warn("Connection lost. Reconnecting...");
});

let currentOrgChannel: RealtimeChannel | null = null;

/** Returns the shared org channel. Stores call this instead of managing channels independently. */
export const getOrgChannel = (): RealtimeChannel | null => currentOrgChannel;

/**
 * Called once when activeOrganization changes. Connects when the user
 * has an active org, disconnects on logout. Individual stores
 * subscribe/unsubscribe event names on the shared channel — they never detach it.
 */
export const switchOrgChannel = (organizationId: string | null) => {
  const hadChannel = currentOrgChannel !== null;

  if (currentOrgChannel) {
    currentOrgChannel.unsubscribe();
    currentOrgChannel.detach();
    currentOrgChannel = null;
  }

  if (organizationId) {
    if (ablyClient.connection.state !== "connected") {
      ablyClient.connect();
    }
    currentOrgChannel = ablyClient.channels.get(organizationId);
  } else if (hadChannel) {
    ablyClient.close();
  }
};
